module.exports = __webpack_public_path__ + "img/icb-empty-elite-m@3x.06246446.png";